<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters" size="mini">
				<el-form-item>
					<el-input v-model="filters.name" placeholder="姓名"></el-input>
				</el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow AddButtonShow  ></my-button>
				</el-form-item>
				<el-form-item>
					<form-setting-button  @select-type="showUser" btnCon="设置父用户" v-if="fatherUserId==0">  </form-setting-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="users" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;" border :height="formHeight" size="mini">
			<el-table-column type="selection">
			</el-table-column>
			<el-table-column type="index" label="序号">
			</el-table-column>
			<el-table-column prop="name" label="姓名" sortable min-width="100">
			</el-table-column>
			<el-table-column prop="userName" label="登录名"  min-width="100">
			</el-table-column>
			<el-table-column prop="sysName" label="系统名称" min-width="100">
			</el-table-column>
			<el-table-column prop="roleName" label="角色名"  sortable>
			</el-table-column>
			<el-table-column prop="email" label="邮箱" min-width="120">
			</el-table-column>
			<el-table-column prop="telephone" label="手机号" min-width="120">
			</el-table-column>
			<el-table-column label="操作" min-width="200px">
				<template slot-scope="scope">
					<table-setting-button  @select-type="handlePermission(scope.$index, scope.row)" btnCon="赋予权限" v-if="fatherUserId==0">  </table-setting-button>
					<table-update-button  @select-type="handleEdit(scope.$index, scope.row)" ></table-update-button>
					<table-update-button  @select-type="resetPwd(scope.$index, scope.row)" btnCon="重置密码"></table-update-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total"
			 style="float:right;" :page-sizes="[10, 20, 30,40,50]"   @size-change="handleSizeChange" :current-page.sync="page">
			</el-pagination>
		</el-col>

		<!--Form界面-->
		<el-dialog :title="type" :visible.sync="formVisible" :close-on-click-modal="false">
			<el-form :model="formUser" label-width="120px" :rules="formRules" ref="formUser">
				<el-form-item label="姓名" prop="name">
					<el-input v-model="formUser.name" ></el-input>
				</el-form-item>
				<el-form-item label="登录名" prop="userName">
					<el-input v-model="formUser.userName" ></el-input>
				</el-form-item>
				<el-form-item label="邮箱" prop="email">
					<el-input v-model="formUser.email"  placeholder="请输入邮箱"></el-input>
				</el-form-item>
				<el-form-item label="手机号" prop="telephone">
					<el-input v-model="formUser.telephone" placeholder="请输入手机号"></el-input>
				</el-form-item>
				<el-form-item label="系统名称" prop="sysName">
					<el-input v-model="formUser.sysName" ></el-input>
				</el-form-item>
				<el-form-item label="角色名称" prop="roleId" >
					<el-select v-model="formUser.roleId" placeholder="请选择角色" filterable  :disabled="fatherUserId!=0">
						<el-option
							v-for="item in rolesList"
							:label="item.roleName"
							:value="item.roleId" :key="item.roleId">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
		<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit">取消</el-button>
				<el-button type="primary" @click.native="submitData" :loading="loading">提交</el-button>
			</div>
		</el-dialog>

		<el-dialog title="授予权限" :visible.sync="permissionVisible" :close-on-click-modal="false">
			<el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
			<el-tree class="filter-tree"  :filter-node-method="filterNode" 
				:data="dataProPer" show-checkbox default-expand-all style="height:700px;overflow:auto"
				node-key="projectId"  :props ="props" ref="proTree" highlight-current   :default-checked-keys="checkProPer">
			</el-tree>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit">取消</el-button>
				<el-button type="primary" @click.native="submitPermission" :loading="loading">提交</el-button>
			</div>
		</el-dialog>

		<!--Form界面-->
		<el-dialog title="设置用户" :visible.sync="userVisible" :close-on-click-modal="false">
			<el-form :model="formFather" label-width="80px" ref="formFather">
				<el-form-item label="父用户" prop="project">
					<el-select v-model="formFather.userId" placeholder="请选择父项目" filterable>
						<el-option label="无" value=0></el-option>
						<el-option
							v-for="item in allUser"
							:label="item.name"
							:value="item.userId" :key="item.userId">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
		<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit">取消</el-button>
				<el-button type="primary" @click.native="setFatherUser" :loading="loading">提交</el-button>
			</div>
		</el-dialog>

	</section>
</template>

<script>
	import { getUserList,getRoles,updateUser,userQueryPermisson,userAddPermission,addUser,
	getUsers,setFatherUser,getWechats} from '../../api/api';

	import myButton from '../../components/myButton/index.vue'
	import TableUpdateButton from '../../components/myButton/TableUpdateButton.vue'
	import TableSettingButton from '../../components/myButton/TableSettingButton.vue'
	import FormSettingButton from '../../components/myButton/FormSettingButton.vue'

	import {in_array} from '../../../static/fun.js';

	export default {
	components: { myButton,TableUpdateButton,TableSettingButton,FormSettingButton},
		data() {
			return {
				filterText: '',
				filters: {
					name: ''
				},
				users: [],
				rolesList:[],
				total: 0,
				page:1,
				pageSize:10,
				listLoading: false,
				sels: [],//列表选中列
				type:'新增',
				dataProPer:[],
				dataProTepPer:[],
				checkProPer:[],
				permissionUserId:0,

				formVisible: false,//修改界面是否显示
				permissionVisible:false,//授予权限页面是否显示
				loading: false,
				formRules: {
					name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
					],
					password: [
						{ required: true, message: '请输入密码', trigger: 'blur' }
					],
					userName: [
						{ required: true, message: '请输入登录名', trigger: 'blur' }
					],
					sysName: [
						{ required: true, message: '请输入系统名称', trigger: 'blur' },
						{ max: 25,  message: '长度必须不大于25位', trigger: 'blur'}
					],
					roleId: [
						{  required: true, message: '请选择角色名', trigger: 'change'}
					]
				},
				formHeight:0,
				//修改界面数据
				formUser: {
					userId: 0,
					name: '',
					userName: '',
					sysName: '',
					email:'',
					telephone:''
				},
				PasswordDefault:'Hc123456',

				userVisible:false,
				wechatVisible:false,
				formFather:{
					userId: ''
				},
				allUser:[],
				allWechat:[],
				fatherUserId:1,

				wechatid:'',
				props:{
					label:"name"
				}
			}
		},
		watch: {
			filterText(val) {
				this.$refs.proTree.filter(val);
			}
		},
		methods: {
			clickBtn(type){
				if(type=="query"){
					this.getUsers();
				}else if(type=="add"){
					this.handleAdd();
				}
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			showUser(){
				this.userVisible=true;
				this.getAllUsers();
			},
			setFatherUser(){
				var ids = this.sels.map(item => item.userId);
				this.listLoading = true;

				var params=new URLSearchParams();
				params.append('subUserIds', ids);
				params.append('parentUserId',this.formFather.userId);

				setFatherUser(params).then((res) => {
					this.listLoading = false;
					
					let resData = res.data;
					if (resData.code == 200) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
					}else{
						this.$message({
							message: resData.msg,
							type: 'error'
						})
					}
					this.userVisible=false;
					this.getUsers();
				});
			},
			
			//查询项目信息
			getAllUsers() {
				if(this.allUser.length>0){
					return;
				}
				this.listLoading = true;
				getUsers().then((res) => {
					this.allUser = res.data.data;
					this.listLoading = false;
				});
			},
			handleCurrentChange(val) {
				this.page=val;
				this.getUsers();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getUsers();
			},
			//获取用户列表
			getUsers() {
				let para = {
					page: this.page,
					limit:this.pageSize,
					name: this.filters.name
				};
				this.listLoading = true;
				getUserList(para).then((res) => {
					this.listLoading = false;
					if(res.data.code!="200"){
						this.$message({
							message: "查询失败，请重试",
							type: 'error'
						})
						return;
					}
					this.total = res.data.data.total;
					this.users = res.data.data.records;
				});
			},
			//显示授予权限界面
			handlePermission: function (index, row) {
				this.checkProPer=[];
				this.dataProPer=[];
				this.filterText='';
				this.permissionUserId=row.userId;
				//获取角色权限
				let para = {
					userId:row.userId
				};
				userQueryPermisson(para).then((res) => {
					
					let resData = res.data;
					if (resData.code != 200) {
						this.$message({
						message: resData.msg,
						type: 'error'
					})}else{
						this.permissionVisible = true;	
						if(this.dataProTepPer.length==0){
							var child=this.translateDataToTree(resData.data.projectList);	
							var obj={
								projectId:0,
								name:'全选（使用筛选功能请勿使用此功能）',
								children:child
							};
							this.dataProTepPer.push(obj);
						}
						this.dataProPer=JSON.parse(JSON.stringify(this.dataProTepPer));
						this.checkProPer=resData.data.checkedProjectIds;
					}
				});
			},
			translateDataToTree(data) {
				let parents = data.filter(value => value.fatherProId == 0 )
				let children = data.filter(value => value.fatherProId !== 0)
				let translator = (parents, children) => {
					parents.forEach((parent) => {
						children.forEach((current, index) => {
							if (current.fatherProId === parent.projectId) {
								let temp = JSON.parse(JSON.stringify(children));
								temp.splice(index, 1);
								translator([current], temp);
								typeof parent.children !== 'undefined' ? parent.children.push(current) : parent.children = [current];
							}
						})
					})
				}
				translator(parents, children)
				
				return parents
			},
			//对角色进行授权
			submitPermission:function(){
				this.loading = true;
			
				var para=new URLSearchParams();
				var ids=this.$refs.proTree.getCheckedKeys();

				if(in_array(0,ids)){
					ids=[0];
				}
				para.append('projectIds', ids);
				para.append('userId',this.permissionUserId);

				userAddPermission(para).then((res) => {
					this.loading = false;
					
					let resData = res.data;
					if (resData.code != 200) {
						this.$message({
						message: '授权失败',
						type: 'error'
					})}else{
							this.$message({
							message: '授权成功',
							type: 'success'
						})					
					}
					this.permissionVisible = false;
				});
            },
			//获取角色列表
			getRoles() {
				this.listLoading = true;
				getRoles().then((res) => {
					this.rolesList = res.data.data;
				});
			},
			//显示修改界面
			handleEdit: function (index, row) {
				this.formVisible = true;
				if( this.$refs.formUser!=undefined){
               		this.$refs.formUser.resetFields();
				}
				this.type='修改';
				this.formUser = Object.assign({}, row);
			},
			//显示新增界面
			handleAdd: function () {
				this.formVisible = true;
				if( this.$refs.formUser!=undefined){
               		this.$refs.formUser.resetFields();
				}
				this.type='新增';
				this.formUser = {
					userId: 0,
					name: '',
					userName: '',
					sysName: '环境噪声监测平台'
				}
			},
			//Form表单提交
            submitData:function(){
                if(this.type=='修改'){
                   this.editSubmit();
                }else{
					this.addSubmit();
                }
            },
			//修改
			editSubmit: function () {
				this.$refs.formUser.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.loading = true;
							let para = Object.assign({}, this.formUser);
							para.password=null;
							updateUser(para).then((res) => {
								this.loading = false;
								let resData = res.data;
								if (resData.code == 200) {
									this.$message({
										message: '操作成功',
										type: 'success'
									});
								}else{
									this.$message({
										message: resData.msg,
										type: 'error'
									})
								}
								this.formVisible = false;
								this.getUsers();
							});
						});
					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.formUser.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.loading = true;
							let para = Object.assign({}, this.formUser);
							//对密码加密
							para.password=hex_md5(this.PasswordDefault);
							addUser(para).then((res) => {
								this.loading = false;
								let resData = res.data;
								if (resData.code == 200) {
									this.$message({
										message: '操作成功',
										type: 'success'
									});
								}else{
									this.$message({
										message: resData.msg,
										type: 'error'
									})
								}
								this.formVisible = false;
								this.getUsers();
							});
						});
					}
				});
			},
			resetPwd: function (index, row) {
				this.$confirm('确认重置此用户的密码吗？', '提示', {}).then(() => {
					this.loading = true;

					this.loading = true;
					let para = Object.assign({}, row);
					para.password=hex_md5(this.PasswordDefault);
					updateUser(para).then((res) => {
						this.loading = false;
						let resData = res.data;
						if (resData.code == 200) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
						}else{
							this.$message({
								message: resData.msg,
								type: 'error'
							})
						}
						this.formVisible = false;
						this.getUsers();
					});
				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			 //取消按钮
            cancleSubmit:function(){
				this.formVisible=false;
				this.permissionVisible=false;
				this.userVisible=false;
				this.wechatVisible=false;
			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight+document.getElementsByClassName('toolbar')[1].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;
			}
		},
		mounted() {
			var user =JSON.parse(sessionStorage.getItem("user"));
			if(user==null){
				this.$message({
					message: "用户已离线，请重新登录",
					type: 'error'
				})
				this.$router.push({ path: '/login' });
				return;
			}else{
				this.fatherUserId=user.fatherUserId;
			}
			
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			this.getUsers();
			this.getRoles();
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// User.vue?06017581